import { createRootRoute, createRoute, createRouter, Link, Outlet } from '@tanstack/react-router';
import { useEffect } from 'react';
import { guardSurface } from '@/lib/platform/surfaces';
import { SURFACES } from '@/lib/gql/__generated__/surfaces';
import { BusTimesPage } from '@/features/selection/BusTimesPage';
import { ScheduleDataPage } from '@/features/schedule/ScheduleDataPage';
import type { AppEntry } from '@/app/routes-types';

export const entry: AppEntry = { default: '/', byRole: {} };
function NotFoundPage() {
  useEffect(() => {
    const root = document.getElementById('root');
    root?.setAttribute('data-app-notfound', '1');
    return () => root?.removeAttribute('data-app-notfound');
  }, []);
  return (
    <main className="mx-auto max-w-lg p-8">
      <h1 className="font-heading text-2xl font-semibold">Page not found</h1>
      <p className="my-4 text-muted-foreground">This bus times page could not be found.</p>
      <Link
        to="/"
        className="text-primary underline hover:no-underline focus-visible:outline-2 focus-visible:outline-ring"
      >
        Back to bus times
      </Link>
    </main>
  );
}
const rootRoute = createRootRoute({ component: () => <Outlet />, notFoundComponent: NotFoundPage });
const busTimesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: BusTimesPage,
  beforeLoad: () => guardSurface(entry, SURFACES['bus-times']),
  staticData: { title: 'Bus times', page: SURFACES['bus-times'], standalone: false, isPublic: true },
});
const scheduleDataRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/schedule-data',
  component: ScheduleDataPage,
  beforeLoad: () => guardSurface(entry, SURFACES['schedule-data']),
  staticData: { title: 'Schedule data', page: SURFACES['schedule-data'], standalone: false, isPublic: true },
});
export const router = createRouter({ routeTree: rootRoute.addChildren([busTimesRoute, scheduleDataRoute]) });
declare module '@tanstack/react-router' {
  interface StaticDataRouteOption {
    title?: string;
    page?: string;
    standalone?: boolean;
    isPublic?: boolean;
  }
  interface Register {
    router: typeof router;
  }
}
